// extracted by mini-css-extract-plugin
export default {"divider":"Divider_divider__dQZXN","line":"Divider_line__XoJgI","text":"Divider_text__wj+TV"};